/* My Acre header predictive search.
   Calls Shopify's /search/suggest and renders the theme's own
   sections/predictive-search.liquid markup, so the results look like the rest
   of the site. One instance per search form (desktop and mobile). */
(function(){
  var ENDPOINT = '/search/suggest';
  var MIN = 2;
  var DELAY = 250;

  /* The theme renders images through rimg, which hides the real <img> inside a
     <noscript> for its own lazy loader. Injected markup never gets that pass,
     so promote the noscript content ourselves. */
  function unwrapImages(scope){
    Array.prototype.forEach.call(scope.querySelectorAll('noscript[data-rimg-noscript]'), function(ns){
      var holder = ns.parentElement;
      if (holder) holder.innerHTML = ns.textContent;
    });
  }

  function init(wrap){
    var form  = wrap.querySelector('form');
    var input = wrap.querySelector('input[name="q"]');
    var out   = wrap.querySelector('[data-ma-results]');
    if (!form || !input || !out) return;

    var timer = null;
    var controller = null;
    var lastTerm = '';

    function close(){
      out.hidden = true;
      out.innerHTML = '';
      input.setAttribute('aria-expanded','false');
    }

    function open(html){
      out.innerHTML = html;
      unwrapImages(out);
      out.hidden = false;
      input.setAttribute('aria-expanded','true');
    }

    function fetchResults(term){
      if (controller) controller.abort();
      controller = ('AbortController' in window) ? new AbortController() : null;

      var url = ENDPOINT
        + '?q=' + encodeURIComponent(term)
        + '&section_id=predictive-search'
        + '&resources%5Btype%5D=product,collection,page,article'
        + '&resources%5Blimit%5D=6';

      fetch(url, controller ? {signal: controller.signal} : undefined)
        .then(function(r){ return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function(html){
          if (term !== lastTerm) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var panel = doc.querySelector('[data-predictive-search]');
          if (panel) { open(panel.outerHTML); } else { close(); }
        })
        .catch(function(){ /* aborted or offline, leave the form usable */ });
    }

    input.setAttribute('role','combobox');
    input.setAttribute('aria-autocomplete','list');
    input.setAttribute('aria-expanded','false');

    input.addEventListener('input', function(){
      var term = input.value.trim();
      lastTerm = term;
      window.clearTimeout(timer);
      if (term.length < MIN) { close(); return; }
      timer = window.setTimeout(function(){ fetchResults(term); }, DELAY);
    });

    input.addEventListener('focus', function(){
      if (input.value.trim().length >= MIN && out.innerHTML === '') {
        lastTerm = input.value.trim();
        fetchResults(lastTerm);
      }
    });

    input.addEventListener('keydown', function(e){
      if (e.key === 'Escape') { close(); input.blur(); }
      if (e.key === 'ArrowDown' && !out.hidden) {
        var first = out.querySelector('a');
        if (first) { e.preventDefault(); first.focus(); }
      }
    });

    out.addEventListener('keydown', function(e){
      if (e.key === 'Escape') { close(); input.focus(); }
    });

    out.addEventListener('click', function(e){
      var btn = e.target.closest ? e.target.closest('.search-flydown__continue') : null;
      if (btn) { e.preventDefault(); form.submit(); }
    });

    document.addEventListener('click', function(e){
      if (!wrap.contains(e.target)) close();
    });
  }

  function boot(){
    Array.prototype.forEach.call(document.querySelectorAll('[data-ma-searchwrap]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
